import React from 'react';
export default function FormTitle(props: any) {
    return (
        <div className="form-title">
            <h1>{props.title}</h1>
            <h2>All mandatory unless specified otherwise</h2>
        </div>
    );
}